import React, { useState, useEffect } from "react";
import {
  Page,
  Icon,
  Badge,
  Link,
  Popup,
  Swiper as SwiperComponent,
  SwiperSlide,
  f7,
  Button,
} from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH, IMG_URL } from "./../globals";
const eatBidsLogo = require("./../images/logo/eatbids-logo.png");

const TabHome = () => {
  const [restdata, setRestDetails] = useState([]);
  const [slidesPerView, setSlidesPerView] = useState(1);
  const [cuisineType, setCuisineType] = useState([]);
  const [restSuggestion, setRestSuggestion] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(null);

  useEffect(() => {
    const updatePerView = () => {
      if (window.innerWidth >= 1200) {
        setSlidesPerView(3);
      } else if (window.innerWidth >= 960) {
        setSlidesPerView(2);
      } else {
        setSlidesPerView(1);
      }
    };
    updatePerView();
    window.addEventListener("resize", updatePerView);
    return () => {
      window.removeEventListener("resize", updatePerView);
    };
  }, []);
  useEffect(() => {
    axios
      .get(API_BASE_URL + "restaurantdetails", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        setRestDetails(response.data);
      })
      .catch((error) => console.log(error));

    axios
      .get(API_BASE_URL + "cuisintype", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => setCuisineType(response.data))
      .catch((error) => console.log(error));
  }, []);

  const openSearchPage = () => {
    f7.views.main.router.navigate({ name: "searchRestaurant" });
  };
  const handleLinkClick = (id) => {
    console.log(id);
    f7.views.main.router.navigate({
      name: "cuisine",
      params: {
        cid: id,
      },
    });
  };
  const suggestionInput = (e) => {
    setRestSuggestion({
      ...restSuggestion,
      [e.target.name]: e.target.value,
      cust_id: localStorage.getItem("id"),
    });
  };
  const reviewSuggestion = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    axios
      .post(API_BASE_URL + "restsuggestion", restSuggestion, {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
      })
      .then((response) => {
        // f7.views.main.router.navigate('/main/', {
        //   reloadAll: true
        // });
        // f7.tab.show('#tab-3');
        f7.toast
          .create({
            text: "Review has been submitted..!",
            position: "top",
            cssClass: "bg-color-teal",
            closeTimeout: 3000,
          })
          .open();
        setIsSubmitting(false);
        // localStorage.removeItem('cartItems');
      })
      .catch((error) =>
        f7.toast
          .create({
            text: "Event date not selected, error encounter..!",
            position: "top",
            cssClass: "bg-color-red",
            closeTimeout: 3000,
          })
          .open()
      );
    setIsSubmitting(false);
    // f7.views.main.router.back({ force: true });
    // f7.tab.show('#tab-3');
  };
  const getAddressData = (e) => {
    const search = e.target.value;
    axios
      .get(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${search}&key=AIzaSyCiIWDa1uPM7N00h_2KvzJIVJBizpCcGTo`,
        {}
      )
      .then((response) => console.log(response))
      .catch((error) => console.log(error));
  };
  return (
    <Page className="p-0 m-0 bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col-sm col-md-offset-12">
          <div className="">
            <section className="section-t-space mt-4">
              <header className="section-t-space noborder">
                <div className="container-lg custom-container px-2">
                  <div className="header">
                    <div className="head-content">
                      <button
                        className="sidebar-btn bg-white"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#offcanvasLeft"
                      >
                        <img
                          src="https://www.eatbids.com/admin/assets/images/apps/small-logo.png"
                          style={{ width: "30px" }}
                        />
                      </button>
                      <div className="header-location">
                        <a href="#location" data-bs-toggle="modal">
                          <h2 className="text-4">EatBids!</h2>
                          <i className="ri-arrow-down-s-line d-arrow" />
                        </a>
                      </div>
                    </div>
                    {/* <a href="notification.html">
                    <Icon ios="material:notifications" aurora="material:notifications" md="material:notifications" size={22}><Badge color="teal">5</Badge></Icon>
                  </a> */}
                  </div>
                </div>
              </header>
            </section>

            {/* <Navbar title="Eatbids" noShadow>
      <NavRight>
        <Link href="/cart/" transition="f7-parallax">
          <Icon material="shopping_bag" iconIos="f7:shopping_bag" color='purple'>
            <Badge color="teal">5</Badge>
          </Icon>
        </Link>
      </NavRight>
    </Navbar> */}

            <div className="custom-container mt-2 p-0">
              {/* <div class="home-slider">
              <div className="home-slider-slide">
                <img src="https://themes.pixelstrap.com/zomo-app/assets/images/banner/banner1.png" className='img-fluid' />
              </div>
              <div className="home-slider-slide">
                <img src="https://themes.pixelstrap.com/zomo-app/assets/images/banner/banner2.png"  className='img-fluid' />
              </div>
              <div className="home-slider-slide">
                <img src="https://themes.pixelstrap.com/zomo-app/assets/images/banner/banner3.png"  className='img-fluid' />
              </div>
            </div> */}
              <section className="search-section mb-2">
                <div className="custom-container p-0">
                  <form className="auth-form search-head" target="_blank">
                    <div className="form-group">
                      <div className="form-input w-100">
                        <input
                          type="text"
                          className="form-control search"
                          onClick={openSearchPage}
                          placeholder="Restaurant, item & more"
                        />
                        <Icon
                          ios="material:search"
                          aurora="material:search"
                          md="material:search"
                          size={22}
                        ></Icon>
                      </div>
                    </div>
                  </form>
                </div>
              </section>
              {/* <SwiperComponent
                // pagination={{ clickable: true }}
                spaceBetween={20}
                slidesPerView={slidesPerView}
                autoplay
                // onSlideChange={() => console.log('slide change')}
              >
                <SwiperSlide className="home-slider-slide">
                  <img
                    src="https://www.eatbids.com//admin/assets/images/apps/banner/banner-1.png"
                    alt=""
                    className="home-slider-slide"
                  />
                </SwiperSlide>
                <SwiperSlide className="home-slider-slide">
                  <img
                    src="https://www.eatbids.com//admin/assets/images/apps/banner/banner-2.png"
                    alt=""
                    className=" home-slider-slide"
                  />
                </SwiperSlide>
                <SwiperSlide className="home-slider-slide">
                  <img
                    src="https://www.eatbids.com//admin/assets/images/apps/banner/banner-3.png"
                    alt=""
                    className=" home-slider-slide"
                  />
                </SwiperSlide>
              </SwiperComponent> */}
            </div>

            <section className="section-t-space mb-0">
              <div className="custom-container p-0">
                <div className="title">
                  <h3 className="mt-0">Cuisine Categories</h3>
                </div>
                <div className="swiper categories">
                  <SwiperComponent
                    // pagination={{ clickable: true }}
                    spaceBetween={20}
                    slidesPerView={4}
                    onSlideChange={() => console.log("slide change")}
                  >
                    {cuisineType.map((element) => (
                      <SwiperSlide>
                        <div className="swiper-slide">
                          <a
                            className="food-categories "
                            onClick={(e) => {
                              handleLinkClick(element.id);
                            }}
                          >
                            <img
                              className="img-fluid categories-img"
                              src={`${element.img}`}
                              alt={`${element.cuisine_name}`}
                            />
                          </a>
                          <h6>{element.cuisine_name}</h6>
                        </div>
                      </SwiperSlide>
                    ))}
                  </SwiperComponent>
                </div>
              </div>
            </section>
            <div
              className="title"
              style={{
                display: "flex",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              <h3
                className="mt-5"
                style={{
                  color: "#092b91",
                  letterSpacing: "0px",
                  lineHeight: 1.3,
                }}
              >
                Obtain quotes from our network of Restaurant/Caterers - Click
                Below
              </h3>
            </div>
            <section className="section-t-space">
              <div
                className="custom-container p-0"
                style={{ marginTop: "-50px", marginBottom: "-10px" }}
              >
                <a href="/addevent/" className="btn btn-success w-100">
                  Request a Bid
                </a>
              </div>
            </section>
            {/* <div className="title">
              <h4 className="mt-2">
                Or order directly from our partners below
              </h4>
            </div> */}
            <section className="section-t-space mt-0 mb-3">
              <div className="custom-container p-0">
                <div
                  className="title"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    textAlign: "center",
                  }}
                >
                  <h3
                    className="mt-0"
                    style={{
                      color: "#092b91",
                      letterSpacing: "0px",
                      lineHeight: 1.3,
                    }}
                  >
                    {" "}
                    Or order directly from our partners below{" "}
                  </h3>
                </div>
                <div className="container p-0">
                  <div className="row gy-3">
                    {restdata.map((restdetail) => (
                      <div className="bid-web-view-div">
                        <a href={`/restaurantdetail/${restdetail.rest_id}/`}>
                          <div className="vertical-product-box restaurant-product-box">
                            <div className="vertical-box-img">
                              <a
                                href={`/restaurantdetail/${restdetail.rest_id}/`}
                              >
                                {restdetail.rest_img !== null ? (
                                  <img
                                    className="img-fluid img"
                                    src={`${IMG_URL}${restdetail.rest_img}`}
                                    alt={restdetail.rest_name}
                                    style={{ height: "120px", width: "100%" }}
                                  />
                                ) : (
                                  <img
                                    className="img-fluid img"
                                    src={require("./../images/no-image.png")}
                                    alt={restdetail.rest_name}
                                    style={{ height: "120px", width: "100%" }}
                                  />
                                )}
                              </a>
                              <div className="like-icon">
                                <i className="ri-heart-3-fill fill-icon" />
                                <div className="effect-group">
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                  <span className="effect" />
                                </div>
                              </div>
                            </div>
                            <div className="vertical-box-details">
                              <div className="vertical-box-head">
                                <div className="restaurant">
                                  <a
                                    href={`/restaurantdetail/${restdetail.rest_id}/`}
                                  >
                                    <h5>{restdetail.rest_name}</h5>
                                  </a>
                                </div>
                                <h6 className="food-items text-capitalize">
                                  {restdetail.cuisine_name}
                                  {/* {restdetail.menu_details.map(
                                    (menu) => menu.menu_item_name + ", "
                                  )} */}
                                </h6>
                              </div>
                              <div className="location-distance">
                                <div className="location1">
                                  <p className="place text-secondary mt-1">
                                    <Icon
                                      ios="material:location_on"
                                      aurora="material:location_on"
                                      md="material:location_on"
                                      size={16}
                                      className="text-success"
                                    ></Icon>{" "}
                                    {restdetail.add_lin_1}{" "}
                                    {restdetail.add_lin_2} {restdetail.city}{" "}
                                    {restdetail.state} {restdetail.zip_code}
                                  </p>
                                  {/* <h6 className="pt-2 pb-2 text-dark">Start from <span className="text-danger">$125</span> for one tray</h6> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </a>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </section>
            {/* <section className="section-t-space mt-2 mb-3">
            <div className="row gy-3">
              <div>
                <Button type="button" popupOpen=".demo-popup"  large  className="btn btn-success w-100 mt-0">
                  restaurant suggestions near me 
                </Button> 
              </div>
            </div>
          </section> */}
            <Popup className="demo-popup custom-web">
              <Page>
                <div className="search-filter modal-dialog modal-fullscreen custom-web">
                  <div className="modal-content">
                    <header className="section-t-space">
                      <div className="container-lg custom-container p-0">
                        <div className="header-panel">
                          <Link />
                          <h2>Restaurant Name</h2>
                          <Link
                            className="btn-close"
                            popupClose
                            style={{ marginRight: "15px" }}
                          />
                        </div>
                      </div>
                    </header>
                    {/* <div className="modal-title text-center">
                    <h2 className="fw-bold1">Add Menu</h2>
                    <Link className="btn-close" popupClose/>
                  </div> */}
                    <section className="section-b-space">
                      <div className="custom-container">
                        <form
                          id="formSuggestRest"
                          onSubmit={reviewSuggestion}
                          className="auth-form profile-form"
                        >
                          <div className="form-group">
                            <label className="form-label fw-semibold">
                              Restaurant Name
                            </label>
                            <div className="form-input mb-4">
                              <input
                                type="text"
                                id="sug_rest_name"
                                className="form-control"
                                value={restSuggestion.sug_rest_name}
                                name="sug_rest_name"
                                required
                                validate
                                onChange={getAddressData}
                                placeholder="Enter restaurant name"
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label className="form-label fw-semibold">
                              Email
                            </label>
                            <div className="form-input mb-4">
                              <input
                                type="email"
                                className="form-control"
                                name="sug_rest_email"
                                id="sug_rest_email"
                                required
                                value={restSuggestion.sug_rest_email}
                                onChange={suggestionInput}
                                validate
                                placeholder="Enter Email Address"
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label className="form-label fw-semibold">
                              Phone number
                            </label>
                            <div className="form-input mb-4">
                              <input
                                type="text"
                                className="form-control"
                                id="sug_rest_phone"
                                name="sug_rest_phone"
                                value={restSuggestion.sug_rest_phone}
                                required
                                validate
                                onChange={suggestionInput}
                                placeholder="Enter Email Address"
                              />
                            </div>
                          </div>
                          <div className="form-group">
                            <label className="form-label fw-semibold">
                              Notes
                            </label>
                            <div className="form-input mb-4">
                              <input
                                type="text"
                                id="sug_rest_note"
                                className="form-control"
                                name="sug_rest_note"
                                value={restSuggestion.sug_rest_note}
                                onChange={suggestionInput}
                                placeholder="Enter Notes"
                              />
                            </div>
                          </div>
                          <Button
                            className="btn btn-success w-100 text-capitalize mt-0"
                            disabled={isSubmitting}
                            large
                            type="submit"
                          >
                            Review suggestions
                          </Button>
                        </form>
                      </div>
                    </section>
                  </div>
                </div>
              </Page>
            </Popup>
          </div>
        </div>
      </div>
    </Page>
  );
};

export default TabHome;
